
import PDFPage from '@/components/pdfs/PDFPage.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PDFParadigmValues',
  props: {
    section: {
      type: Number,
      required: true,
    },
    context: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      signs: {
        below: `${decodeURI('%3C')}`,
        belowOrEqual: `${decodeURI('%E2%89%A4')}`,
        aboveOrEqual: `${decodeURI('%E2%89%A5')}`,
      },
    }
  },
  components: { PDFPage },
})
